import { render } from "./welcomePage.vue?vue&type=template&id=d31410b4&scoped=true&lang=he"
import script from "./welcomePage.vue?vue&type=script&lang=js"
export * from "./welcomePage.vue?vue&type=script&lang=js"

import "./welcomePage.vue?vue&type=style&index=0&id=d31410b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d31410b4"]])

export default __exports__